import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    ref: "animator",
    class: "loader-text fira-code-400"
  }, _toDisplayString($props.status), 513 /* TEXT, NEED_PATCH */))
}